import { ModalDialog, ModalService } from './base/shared/modal/modal.service';
import { PreventShrinkService } from './base/services/prevent-shrink.service';
import { LanguageService } from './base/services/language.service';
import { WideFormatService } from './base/services/wide-format.service';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { AuthService } from './base/services/auth.service';
import { environment } from 'src/environments/environment';
import { ModalComponent } from './base/shared/modal/modal.component';
import { ToastsComponent } from './base/toasts/toasts.component';
import { RouterOutlet } from '@angular/router';
import { SpinnerComponent } from './base/spinner/spinner.component';
import { NgClass } from '@angular/common';
import { NavigationComponent } from './base/navigation/navigation.component';
import { TenantThemeService } from './base/services/tenant-theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NavigationComponent, NgClass, SpinnerComponent, RouterOutlet, ToastsComponent, ModalComponent]
})
export class AppComponent {


  public get useWideFormat() {
    return this.wideFormatService.useWideFormat;
  }

  public get noShrink() {
    return this.preventShrinkService.preventShrink;
  }

  private timeoutWarning: ModalDialog | null = null;

  constructor(private translate: TranslateService,
              private keepAlive: Keepalive,
              private idle: Idle,
              private modalService: ModalService,
              private authService: AuthService,
              private languageService: LanguageService,
              private wideFormatService: WideFormatService,
              private preventShrinkService: PreventShrinkService,
              private tenantThemeService: TenantThemeService) {
    // Initialize the languageservice
    this.languageService.init();

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    // const browserLang: string = translate.getBrowserLang();
    // translate.use(browserLang.match(/de/) ? browserLang : 'hu');
    this.tenantThemeService.initializeForUser(this.authService.getUserInfo()).subscribe();
    this.configureIdle();
    this.configureKeepAlive();
  }

  private configureKeepAlive() {
    this.keepAlive.interval(30);
    this.keepAlive.onPing.subscribe(() => {
      this.authService.updateActivityTimeStamp();
    });
  }

  private configureIdle() {
    this.idle.setIdle(environment.idleTimeoutInSeconds);
    this.idle.setTimeout(60);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => {
      const dialog = this.timeoutWarning;
      if (dialog) {
        this.modalService.closeDialog(dialog);
      }
      this.timeoutWarning = null;
    });

    this.idle.onTimeout.subscribe(() => {
      if (this.timeoutWarning) {
        this.modalService.closeDialog(this.timeoutWarning);
      }
      this.timeoutWarning = null;
      this.authService.logout();
    });

    this.idle.onTimeoutWarning.subscribe((countdown) => {
      const message = this.translate.instant('i18n.core.modal.idle.message', { params: countdown });
      if (!this.timeoutWarning) {
        if (!this.idle.isIdling()) {
          return;
        }
        this.timeoutWarning = this.modalService.showMessageDialog('i18n.core.modal.idle.title', message);
      } else {
        this.timeoutWarning.message = this.translate.instant('i18n.core.modal.idle.message', { params: countdown });
      }
    });
  }
}
